import { api } from '../utils/api';

export type HandoffStage = 'setup' | 'foundation' | 'method' | 'calculate' | 'attest' | 'deliver';
export type HandoffSeat = 'data_specialist' | 'accountant' | 'attorney';

/** Optional `handoff` dict carried on every queue case row. */
export interface CaseHandoff {
  current_stage: HandoffStage;
  stage_index: number; // 1-6
  next_seat: HandoffSeat | null;
  signed_off_by: string | null;
  signed_off_at: string | null;
  attested_by: string | null;
  attested_at: string | null;
}

/** GET /api/v1/queue/case-handoff/{caseId} */
export interface CaseHandoffDetail extends CaseHandoff {
  overdue: boolean;
  attestation_pending: boolean;
  next_action?: string | null;
}

export function fetchCaseHandoff(caseId: string, signal?: AbortSignal): Promise<CaseHandoffDetail> {
  return api.get<CaseHandoffDetail>(`/api/v1/queue/case-handoff/${encodeURIComponent(caseId)}`, {
    signal,
    showErrorToast: false,
  });
}
